export default __webpack_public_path__ + "static/media/oracle.dde8d748.svg";